export const defaultValue = {
    id: null,
    productCode: null,
    productName: null,
    schema: null,
    cardType: 'DEBIT',
    cardForm: 'PHYSICAL',
    status: 'ACTIVE',
    description: null,
    displayOrder: 0,
    defaultValidityYears: 3,
    minKycLevel: 'L1',
    monthlyFeeAmount: 0,
    annualFeeAmount: 0,
    issuanceFeeAmount: 0,
    replacementFeeAmount: 0,
    maintenanceFee: 0,
    maxCardsPerCustomer: 5,
    requiresApprovalForIssuance: false,
    targetCustomerSegment: 'INDIVIDUAL',
    effectiveFrom: null,
    effectiveUntil: null,
    atmAllowed: true,
    posAllowed: true,
    ecommerceAllowed: true,
    contactlessAllowed: true,
    internationalAllowed: false,
    cashWithdrawalAllowed: true,
    interchangeScope: 'DOMESTIC',
    authorizationRequirement: 'NORMAL',
    usageRestriction: 'NO_RESTRICTIONS',
    commissionGroupCode: null,
    rewardGroupCode: null,
    pricingGroupCode: null,
    createdAt: null,
    updatedAt: null,
    cardLimits: [],
    cardRestrictions: [],
};
